import SearchResultCard, {
  Props as SearchResultCardProps,
} from '@rover/components/src/cards/SearchResultCard/SearchResultCard';
import { emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';
import { getIsPriceTransparency } from '@rover/utilities/priceTransparency';

import { SelectedProviderSearchResultClick } from './analyticsEvents';

export type Props = SearchResultCardProps & {
  startDate?: Date;
  endDate?: Date;
  dates?: string;
};

const SelectedProvider = ({
  searchResult,
  language,
  priceTransparencyLevel,
  ...searchResultCardProps
}: Props): JSX.Element => {
  const { isBestMatch, maybeBestMatch } = searchResult;

  const onClick = (entityOpk, isFacility): void => {
    if (!getIsPriceTransparency(priceTransparencyLevel)) {
      emitAnalyticsEvent(
        new SelectedProviderSearchResultClick({
          providerOpk: entityOpk,
          isFacility,
        })
      );
    }

    searchResultCardProps.onClick?.(
      entityOpk,
      isFacility,
      searchResult.rank,
      !!isBestMatch,
      !!maybeBestMatch
    );
  };

  return (
    <SearchResultCard
      searchResult={searchResult}
      language={language}
      {...searchResultCardProps}
      onClick={onClick}
      priceTransparencyLevel={priceTransparencyLevel}
      isSelectedProviderResult
    />
  );
};

export default SelectedProvider;
